import { Badge, Box, Flex, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue, UltrasoundData, UltrasoundStudyType } from '@hb/shared'
import { SectionLabel } from '../../SectionLabel'

const studyTypeLabel: Record<UltrasoundStudyType, string> = {
  'limited-pocus': 'Limited POCUS',
  'standard-ob': 'Standard OB',
  detailed: 'Detailed',
  bpp: 'BPP',
  'nst-us': 'NST + Ultrasound',
  transvaginal: 'Transvaginal',
}

const LabelText = ({ label }: { label: string }) => (
  <Text fontSize="xs" fontWeight={600} color="gray.500" _dark={{ color: 'gray.400' }} mb={0.5}>
    {label}
  </Text>
)

const gaDisplay = (days: number) => {
  const w = Math.floor(days / 7)
  const d = days % 7
  return `${w}w ${d}d`
}

export const UltrasoundHeaderView = ({ data }: { data: FieldMapValue }) => {
  const d = data as UltrasoundData
  if (!d.studyDate && !d.studyType) return null

  return (
    <VStack align="stretch" spacing={3} w="100%">
      <SectionLabel>Ultrasound Report</SectionLabel>
      <Flex gap={4} flexWrap="wrap">
        {d.studyDate && (
          <Box>
            <LabelText label="Study Date" />
            <Text fontSize="sm">{d.studyDate}</Text>
          </Box>
        )}
        {d.gaAtStudyDays != null && (
          <Box>
            <LabelText label="GA at Study" />
            <Text fontSize="sm">{gaDisplay(d.gaAtStudyDays)}</Text>
          </Box>
        )}
        {d.studyType && (
          <Box>
            <LabelText label="Study Type" />
            <Badge colorScheme="blue" fontSize="xs">
              {studyTypeLabel[d.studyType]}
            </Badge>
          </Box>
        )}
        {d.orderingProvider && (
          <Box>
            <LabelText label="Ordering Provider" />
            <Text fontSize="sm">{d.orderingProvider}</Text>
          </Box>
        )}
      </Flex>
      {d.indication && (
        <Box>
          <LabelText label="Indication" />
          <Text fontSize="sm">{d.indication}</Text>
        </Box>
      )}
      {d.deviceEquipment && (
        <Box>
          <LabelText label="Device / Equipment" />
          <Text fontSize="sm">{d.deviceEquipment}</Text>
        </Box>
      )}
      {d.imagesArchived && (
        <Badge colorScheme="green" fontSize="xs">
          Images Archived
        </Badge>
      )}
    </VStack>
  )
}
